import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  card: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    position: 'relative',
    padding: "20px 10px",
    borderStyle: 'solid',
    borderColor: 'grey'
  },
  
}));
